import {
  INCIDENT_STATUS,
  SEVERITY_LEVELS,
} from 'xm-constants/incidentManagement';

export const SERVICE_TYPES = {
  TECHNICAL: 'TECHNICAL',
  APPLICATION: 'APPLICATION',
  MIXED: 'MIXED', // Not a real service type - just to denote we have multiple types
};

export const COLUMN_NAMES = {
  SERVICE: 'SERVICE',
  OWNER: 'OWNER',
  SERVICE_TIERS: 'TIERS',
  SERVICE_TYPES: 'TYPES',
  ACTIVE_INCIDENTS: 'ACTIVE_INCIDENTS',
};

export const INCIDENT_SEVERITIES = SEVERITY_LEVELS;
export const INCIDENT_STATUSES = INCIDENT_STATUS;

export const SERVICE_OWNER_RELATIONSHIP = {
  ANY: 'ANY',
  MEMBER: 'MEMBER',
  NOT_OWNED: 'NOT_OWNED',
  SUPERVISOR: 'SUPERVISOR',
};

export const defaultDropdownFilters = {
  owner: {
    loggedInUserId: '',
    selected: [],
  },
  search: '',
  severity: INCIDENT_SEVERITIES.MINIMAL,
  sortBy: '',
  sortOrder: '',
  serviceTiers: '',
};
